import StartPage from "../components/StartPage";

export default [
    { path: "/", component: StartPage }
];